// Catálogo CERRADO de tipos de campo (doc 0417 §4, M-2) — el mismo que lee
// `embed.js` (backend) para decidir el `<input>`/`<textarea>` a renderizar.
// Un campo nuevo se declara UNA VEZ aquí y aparece en la paleta del Builder.
export const WEB_FORM_FIELD_CATALOG = [
  { tipo: "nombre", label: "Nombre completo" },
  { tipo: "whatsapp", label: "WhatsApp" },
  { tipo: "correo", label: "Correo electrónico" },
  { tipo: "fecha", label: "Fecha preferida" },
  { tipo: "servicio", label: "Servicio" },
  { tipo: "nota", label: "Comentario" },
  { tipo: "texto_libre", label: "Título / Texto informativo" }
];

export const fieldCatalogLabel = tipo =>
  WEB_FORM_FIELD_CATALOG.find(f => f.tipo === tipo)?.label || tipo;

// "texto_libre" es el ÚNICO campo del catálogo que NO es una entrada: es
// texto decorativo fijo (un título/subtítulo/aviso dentro del formulario) —
// el visitante lo LEE, no lo llena (2026-09-19, a pedido del propietario:
// "Texto libre" con caja de entrada no tenía uso claro; como texto fijo,
// sí). Builder (`FormPreview`/`FieldListEditor`) y `embed.js`
// (`embedScript.ts`) lo tratan aparte con esta misma función.
export const isLabelOnlyField = tipo => tipo === "texto_libre";

// Mismo mapeo tipo→input que usa `embed.js` (backend, `views/embedScript.ts`)
// para que la vista previa del Builder coincida con lo que de verdad verá el
// visitante. Dos copias por fuerza mayor (frontend/backend son bundles
// separados), pero UN solo criterio: si se agrega un tipo de campo, se toca
// este archivo Y `embedScript.ts` a la vez. "texto_libre" no aparece aquí:
// no tiene input que mapear.
export const WEB_FORM_FIELD_INPUT_TYPE = {
  nombre: "text",
  whatsapp: "tel",
  correo: "email",
  fecha: "date",
  servicio: "text",
  nota: "textarea"
};
